import React from 'react'
import AdminUserProfileContainer from '../../modules/AdminUserProfile/containers/AdminUserProfileContainer/AdminUserProfileContainer'

const AdminUserProfile = () => {
  return (
    <AdminUserProfileContainer />
  )
}

export default AdminUserProfile